import { useSelector } from "react-redux";
import * as EncryptedKey from '../constants/encryptedRootReducerKeys';

export const useAllSelector = () => {

	const switchPharmacyResponse = useSelector((state) => state[EncryptedKey.switchPharmacy]);
	const patientDataBasisOfRouteResponse = useSelector((state) => state[EncryptedKey.patientDataBasisOfRoute]);

	const patientDeliveredDataBasisOfRouteResponse = useSelector((state) => state[EncryptedKey.patientDeliveredDataBasisOfRoute]);
	const pharmacistOfPharmacyListResponse = useSelector((state) => state[EncryptedKey.pharmacistOfPharmacyList]);
	const todayMissedListResponse = useSelector((state) => state[EncryptedKey.todayMissedList])
	const driverDeliveredRouteListResponse = useSelector((state) => state[EncryptedKey.driverDeliveredRouteList]);

	const patientSearchListResponse = useSelector((state) => state.patientSearchList);
	const changePasswordResponse = useSelector((state) => state.changePassword);
	const changePasscodeResponse = useSelector((state) => state.changePasscode);
	const uploadImageResponse = useSelector(state => state.uploadImage)

	const driverLogoutResponse = useSelector((state) => state.driverLogout);
	const logoutBlockedMessage = useSelector((state) => state.driverLogout?.blockedMessage);

	const patientDeliveryRxListResponse = useSelector((state) => state.patientDeliveryRxList);
	const patientPendingListResponse = useSelector((state) => state.patientPendingList);
	const vitalPatientsResponse = useSelector((state) => state.vitalPatients);
	const confirmDeliveryResponse = useSelector((state) => state.confirmDelivery);

	const updateProfileResponse = useSelector((state) => state.updateProfile);
	const getDriverProfileResponse = useSelector((state) => state.getDriverProfile);
	const driverProfilePhoto = useSelector((state) => state.driverProfilePhoto);
	const finalMissedListResponse = useSelector((state) => state.finalMissedList);
	const updateDeliveryListResponse = useSelector((state) => state.updateDeliveryList);

	const patientConsentResponse = useSelector((state) => state.patientConsent);
	const allPharmacyListResponse = useSelector((state) => state.allPharmacyList);

	const pharmacistDetail = pharmacistOfPharmacyListResponse?.data?.data?.pharmacist
	const routeListResponse = pharmacistOfPharmacyListResponse?.data?.data?.route
	const supervisor_pharmacist = pharmacistOfPharmacyListResponse?.data?.data?.supervisor_pharmacist

	const pharmacyDetail = switchPharmacyResponse?.data?.data
	const todayMissedList = todayMissedListResponse?.data?.data

	const deliveredRoutes = driverDeliveredRouteListResponse?.data?.data || [];
	const todaysDispenseList = patientDataBasisOfRouteResponse?.data

	const deliveredCount = pharmacistOfPharmacyListResponse?.data?.data?.delivered_count
	const finalMissedCount = pharmacistOfPharmacyListResponse?.data?.data?.final_missed_count
	const supervisorOfTheDay = pharmacistOfPharmacyListResponse?.data?.data?.supervisorOfTheDays
	const pharmacist_assistant_status = pharmacistOfPharmacyListResponse?.data?.data?.assistant_status?.status
	const pharmacy_assign_chat = pharmacistOfPharmacyListResponse?.data?.data?.assign_chat

	const pharmacy_assign_driver_chat = pharmacistOfPharmacyListResponse?.data?.data?.assign_chat?.driver_id
	const pharmacy_assign_pharmacist_chat = pharmacistOfPharmacyListResponse?.data?.data?.assign_chat?.pharmacist_id

	const pharmacy_assign_chats = pharmacy_assign_driver_chat || pharmacy_assign_pharmacist_chat

	const patientRxData = patientDeliveryRxListResponse?.data?.data?.patient
	const finalMissedList = finalMissedListResponse?.data?.data

	const todaysAnalyticsResponse = useSelector(state => state?.todaysAnalytics)
	const UploadPrescripitionResponse = useSelector(state => state.UploadPrescripition)
	const updatePatientProfileResponse = useSelector(state => state.updatePatientProfile)
	const validateReturnedPatchesResponse = useSelector(state => state.validateReturnedPatches)
	const UploadedTriplicatesPatientSignResponse = useSelector(state => state.UploadedTriplicatesPatientSign)
	const GenrateRxLinkResponse = useSelector(state => state.GenrateRxLink)

	const analyticSupervisorOftheDay = todaysAnalyticsResponse?.data?.data?.supervisorOfTheDays

	const flexiDeliverResponse = useSelector(state => state.flexiDeliver)
	const missedRx3x4xResponse = useSelector(state => state.missedRx3x4x)

	const checkUnassignedVitalPatientsResponse = useSelector(state => state.pendingCounselling?.checkUnassignedVitalPatients)
	const hasUnassignedVital = checkUnassignedVitalPatientsResponse?.data?.data?.has_unassigned_vital === true

	return {
		switchPharmacyResponse,
		changePasswordResponse,
		changePasscodeResponse,
		flexiDeliverResponse,
		missedRx3x4xResponse,
		uploadImageResponse,

		driverLogoutResponse,
		logoutBlockedMessage,
		routeListResponse,
		patientDataBasisOfRouteResponse,
		patientDeliveredDataBasisOfRouteResponse,

		patientSearchListResponse,
		pharmacistOfPharmacyListResponse,
		patientDeliveryRxListResponse,
		supervisor_pharmacist,

		patientPendingListResponse,
		vitalPatientsResponse,
		confirmDeliveryResponse,
		updateProfileResponse,
		getDriverProfileResponse,
		driverProfilePhoto,

		finalMissedListResponse,
		todayMissedListResponse,
		updateDeliveryListResponse,

		driverDeliveredRouteListResponse,
		patientConsentResponse,
		allPharmacyListResponse,

		pharmacyDetail,
		pharmacistDetail,
		todayMissedList,
		deliveredRoutes,
		todaysDispenseList,

		deliveredCount,
		finalMissedCount,
		patientRxData,
		finalMissedList,
		todaysAnalyticsResponse,
		UploadPrescripitionResponse,
		updatePatientProfileResponse,
		validateReturnedPatchesResponse,
		UploadedTriplicatesPatientSignResponse,
		GenrateRxLinkResponse,
		supervisorOfTheDay,

		analyticSupervisorOftheDay,
		pharmacist_assistant_status,
		pharmacy_assign_chat,

		pharmacy_assign_chats,

		checkUnassignedVitalPatientsResponse,
		hasUnassignedVital
	}
}